import React from 'react'
import styled from 'styled-components'

import { ReactComponent as CalendarIcon } from '@/assets/svgs/calendar-plant-clock.svg'
import { ReactComponent as ChainLinksIcon } from '@/assets/svgs/chain-links.svg'
import { AssistanceSection, Layout, InformationSection } from '@/components'
import { theme } from '@/theme'
import { Button } from '@/UIkit/Button'
import { IconGenerator } from '@/UIkit/IconGenerator'

const LongMargin = styled.div`
  margin-bottom: 24px;
`

const ShortMargin = styled.div`
  margin-bottom: 16px;
`

const MidWeight = styled.div`
  font-weight: ${theme.fontWeight.normal};
`

const Bold = styled.span`
  font-weight: ${theme.fontWeight.medium};
`

const ButtonLink = styled(Button)`
  padding: 0;
  background: none;
  min-height: 0;
`

export const MFAInstructions = ({
  onClickLink,
  emailAddress,
}: {
  onClickLink: () => void
  emailAddress: string
}) => (
  <Layout largeLogo>
    <InformationSection
      title="Check your inbox!"
      iconProps={{ iconComponent: CalendarIcon, width: 175, height: 150 }}
    >
      <LongMargin>We’ve sent a verification email to {emailAddress}</LongMargin>
      <LongMargin>
        To log in and complete verification, simply open the AltoVita add-in
        while viewing the verification email.
      </LongMargin>
      <ShortMargin>
        <Bold>Didn’t receive the email?</Bold>
        <MidWeight>Check your spam or junk folder</MidWeight>
      </ShortMargin>
      <ButtonLink
        mode="link"
        onClick={onClickLink}
        icon={
          <IconGenerator
            iconComponent={ChainLinksIcon}
            width={24}
            height={24}
          />
        }
      >
        Resend email
      </ButtonLink>
    </InformationSection>
    <AssistanceSection />
  </Layout>
)
